import { render, staticRenderFns } from "./Veripay.vue?vue&type=template&id=6819c58c&"
import script from "./Veripay.vue?vue&type=script&lang=js&"
export * from "./Veripay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports